import "./assets/resume.css";
const experience = [
  {
    company: "Alibaba",
    logo: "alibaba.png",
    team: "Accio Team",
    role: "Algorithm Engineer",
    dates: "2026.03 — Present",
    detail: "Working on Agent Harness.",
    current: true,
  },
  {
    company: "Xiaomi Tech.",
    logo: "xiaomi.svg",
    team: "Xiaoai",
    role: "Algorithm Intern · Onsite",
    dates: "2025.05 — 2025.09",
    detail: "Large Language Models (LLMs).",
    location: "China",
  },
  {
    company: "PKUSE Co.",
    logo: "pkuse.png",
    role: "Cooperative Intern · Onsite",
    dates: "2024.03 — 2024.06",
    detail: "Algorithm Development.",
    location: "Beijing, China",
  },
  {
    company: "Nanyang Technological University",
    logo: "ntu.png",
    role: "Intern · Onsite",
    dates: "2023.11 — 2024.02",
    detail: "School of Computer Science and Engineering.",
    location: "Singapore",
  },
  {
    company: "University of Hong Kong",
    logo: "hku.png",
    role: "Intern · Onsite",
    dates: "2023.07 — 2023.09",
    detail: "Department of Computer Science.",
    location: "Hong Kong, China",
  },
  {
    company: "Beihang University",
    logo: "buaa.png",
    role: "Academic Assistant",
    dates: "2022.09 — 2023.01 / 2023.09 — 2024.01",
    detail: "Computer Organisation, Compile Technology.",
    location: "Beijing, China",
  },
];
const education = [
  {
    company: "National University of Singapore",
    logo: "nus.png",
    role: "Master of Science · Computer Science",
    dates: "2024.08 — 2026.01",
    location: "Singapore",
  },
  {
    company: "Beihang University (BUAA)",
    logo: "buaa.png",
    role: "Bachelor of Engineering · Computer Science and Engineering",
    dates: "2020.09 — 2024.07",
    location: "Beijing, China",
  },
];

function ResumeEntry({ item }) {
  return (
    <article className="resume-entry resume-entry-with-icon">
      <div className="organization-icon">
        <img
          className={item.company === "Alibaba" ? "alibaba-icon" : undefined}
          src={`/images/organizations/${item.logo}`}
          alt={`${item.company} logo`}
          width="44"
          height="44"
        />
      </div>
      <div className="resume-entry-content">
        <div className="resume-entry-top">
          <h3>{item.company}</h3>
          {item.current && <span className="current-badge">Current</span>}
          <span className="resume-dates">{item.dates}</span>
        </div>
        <p className="resume-role">
          {item.role}
          {item.team && ` · ${item.team}`}
          {item.location && (
            <span className="resume-location">{item.location}</span>
          )}
        </p>
        {item.detail && <p>{item.detail}</p>}
      </div>
    </article>
  );
}

export default function Resume() {
  return (
    <div className="resume-page">
      <header className="resume-header">
        <div>
          <h1>
            Zijie Lin<span>林子杰</span>
          </h1>
          <p>Algorithm Engineer · Alibaba Accio Team</p>
        </div>
        <a className="text-link" href="mailto:lin.zijie@u.nus.edu">
          Get in touch ↗
        </a>
      </header>
      <section className="resume-section">
        <div className="resume-label">
          <h2>Experience</h2>
        </div>
        <div>
          {experience.map((item) => (
            <ResumeEntry key={item.company} item={item} />
          ))}
        </div>
      </section>
      <section className="resume-section">
        <div className="resume-label">
          <h2>Education</h2>
        </div>
        <div>
          {education.map((item) => (
            <ResumeEntry key={item.company} item={item} />
          ))}
        </div>
      </section>
      <section className="resume-section">
        <div className="resume-label">
          <h2>Skills</h2>
        </div>
        <div className="skills-list">
          <div>
            <h3>Programming & writing</h3>
            <p>
              C, C++, Java, Python, Golang, Verilog, JavaScript, HTML, LaTeX,
              Markdown
            </p>
          </div>
          <div>
            <h3>Frameworks & tools</h3>
            <p>Agent Harness, LLMs, Linux, ReAct, Git, Docker</p>
          </div>
          <div>
            <h3>Languages</h3>
            <p>
              Chinese (Native) · Cantonese · English (IELTS Band 7) · Japanese
              (Novice)
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
